export const locale = {
    id: 'es-ES',
    prefix: '',
    mailDomain: 'es',
};
